import { morphSection } from '@theme/section-renderer';

/* ============================================================
   Venora - carrito a medida (tema Horizon)

   El cliente paga 1, 2 o 3 pares:
     1 par   -> recibe 1
     2 pares -> recibe 4 (2 + 2 gratis)
     3 pares -> recibe 8 (3 + 5 gratis)

   La linea del carrito lleva la talla y el color del par 1.
   El color de cada par y la lista de regalos viajan al checkout
   como propiedades de esa linea, asi que el checkout cuenta lo
   que de verdad se cobra.

   Cada cambio de cantidad es UNA peticion y UN repintado.
   ============================================================ */

const SECTION = 'cart-drawer-section';
const PROP = 'Te regalamos';
const PROP_COLORS = 'Colores';
const RESERVA_MIN = 10;
/* Exclusivo packs 2 y 3: habilitar solo cuando Digital Products
   confirme que el PDF está asociado al producto de regalo. */
function venoraEbookReady() { return true; }
const VENORA_EBOOK_VARIANT = 59257993724239;
const VENORA_SOCKS_PRODUCT = 16414020698447;
let busy = false;

/* ------------------------------------------------------------
   El selector de cantidad nativo de Horizon sigue en el DOM
   (lo tapamos con CSS) y disparaba sus propias peticiones al
   repintar, con indices de linea viejos: borraba lineas y
   cambiaba cantidades por su cuenta. Lo cortamos en la fase de
   captura, antes de que cart-items-component lo escuche.
   ------------------------------------------------------------ */
document.addEventListener(
  'quantity-selector:update',
  function (ev) {
    const t = ev.target;
    if (t && t.closest && t.closest('#cart-drawer')) {
      ev.stopImmediatePropagation();
      ev.stopPropagation();
      ev.preventDefault();
    }
  },
  true
);

/* ------------------------------------------------------------
   Aviso visible. Antes, cualquier error del carrito acababa en
   window.location.reload(): la pagina se recargaba y el cliente
   no se enteraba de nada. Ahora se le dice que ha pasado.
   ------------------------------------------------------------ */
let avisoTimer = null;
function aviso(msg) {
  let el = document.getElementById('venora-aviso');
  if (!el) {
    el = document.createElement('div');
    el.id = 'venora-aviso';
    el.setAttribute('role', 'alert');
    el.style.cssText =
      'position:fixed;left:16px;right:16px;bottom:16px;z-index:100000;' +
      'max-width:520px;margin:0 auto;padding:12px 14px;border-radius:10px;' +
      'background:#fdecec;color:#9b1c1c;border:1px solid #f5c2c2;' +
      'font-size:14px;line-height:19px;text-align:center;' +
      'box-shadow:0 6px 24px rgba(0,0,0,.15)';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.hidden = false;
  clearTimeout(avisoTimer);
  avisoTimer = setTimeout(function () { el.hidden = true; }, 7000);
}

function box() { return document.querySelector('[data-venora-cart]'); }
function shell() { return document.querySelector('cart-drawer-component'); }
function num(el, attr) { return el ? parseInt(el.getAttribute(attr), 10) || 0 : 0; }

function openDrawer() {
  const d = document.querySelector('theme-drawer#cart-drawer');
  if (d && typeof d.open === 'function') d.open();
}

function freeFor(n) {
  if (n >= 3) return 5;
  if (n === 2) return 2;
  return 0;
}

function giftText(n) {
  if (n < 1) return '';
  const out = [];
  const free = freeFor(n);
  if (free > 0) out.push(free + ' pares GRATIS');
  out.push('Envio gratis');
  if (n >= 2) out.push('Ebook');
  if (n >= 3) out.push('Garantia 2 anos');
  return out.join(' · ');
}

/* La lista de colores se estira o se recorta al cambiar de pack:
   los pares nuevos salen del color del primer par. */
function colorsFor(n) {
  const d = box();
  const raw = d ? d.getAttribute('data-colors') || '' : '';
  const arr = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  if (!arr.length) return '';
  const pairs = n + freeFor(n);
  while (arr.length < pairs) arr.push(arr[0]);
  arr.length = pairs;
  return arr.join(', ');
}

/* En el cajon ensenamos los colores pero no la lista de regalos,
   que ya sale en el recuadro verde. En el checkout salen las dos. */
function tidyProps() {
  document.querySelectorAll('#cart-drawer .cart-items__property').forEach(function (p) {
    const dt = p.querySelector('dt');
    if (dt && dt.textContent.indexOf(PROP) > -1) p.setAttribute('data-v-hide', '');
    else p.removeAttribute('data-v-hide');
  });
}

function setBusy(on, btn) {
  busy = on;
  const s = shell();
  if (s) s.classList.toggle('vcart-busy', on);
  if (btn) btn.disabled = on;
}

function bumpCount(count) {
  if (typeof count !== 'number') return;
  document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
    el.textContent = count > 0 ? String(count) : '';
  });
}

/* Sincroniza el regalo según la cantidad de medias realmente pagadas.
   Pack 1: 0 ebooks. Packs 2/3: 1 ebook por carrito. */
async function syncEbookGift() {
  if (!venoraEbookReady()) return null;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
  if (!cartResponse.ok) throw new Error('No se pudo comprobar el carrito');
  const cart = await cartResponse.json();
  const qualifies = (cart.items || []).some(function (item) {
    return Number(item.product_id) === VENORA_SOCKS_PRODUCT && Number(item.quantity) >= 2;
  });
  const current = (cart.items || []).filter(function (item) {
    return Number(item.variant_id) === VENORA_EBOOK_VARIANT;
  }).reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
  const desired = qualifies ? 1 : 0;
  if (current === desired) return null;
  const updates = {};
  updates[String(VENORA_EBOOK_VARIANT)] = desired;
  const response = await fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates: updates, sections: SECTION, sections_url: window.location.pathname })
  });
  const result = await response.json();
  if (!response.ok || (result.status && result.status >= 400)) {
    throw new Error(result.description || result.message || 'No se pudo actualizar el regalo');
  }
  return result;
}

async function post(url, payload, btn) {
  if (busy) return false;
  setBusy(true, btn);
  try {
    payload.sections = SECTION;
    payload.sections_url = window.location.pathname;
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const json = await res.json();
    if (json.status && json.status >= 400) throw new Error(json.description || json.message || 'cart error');
    const html = json.sections && json.sections[SECTION];
    if (!html) {
      // La peticion fue bien pero no nos devolvieron el cajon: recargar
      // es la forma segura de que el cliente vea su carrito al dia.
      window.location.reload();
      return false;
    }
    await morphSection(SECTION, html, { mode: 'hydration' });
    if (typeof json.item_count === 'number') bumpCount(json.item_count);
    if (venoraEbookReady()) {
      try {
        const gift = await syncEbookGift();
        if (gift) {
          const giftHtml = gift.sections && gift.sections[SECTION];
          if (giftHtml) await morphSection(SECTION, giftHtml, { mode: 'hydration' });
          if (typeof gift.item_count === 'number') bumpCount(gift.item_count);
        }
      } catch (e) {
        console.warn('[venora-ebook]', e);
        aviso('No se pudo actualizar el e-book de regalo. Revisa tu carrito.');
      }
    }
    tidyProps();
    reserva();
    return true;
  } catch (err) {
    console.warn('[venora-cart]', err);
    aviso(err && err.message ? err.message : 'No se pudo actualizar el carrito. Inténtalo de nuevo.');
    return false;
  } finally {
    setBusy(false, btn);
  }
}

/* Fija los pares pagados a un valor exacto, con sus regalos y colores. */
function setPairs(target, btn) {
  const d = box();
  if (!d) return Promise.resolve(false);
  const line = num(d, 'data-line');
  if (!line) return Promise.resolve(false);
  let q = target;
  if (q < 1) q = 1;
  if (q > 3) q = 3;
  const props = {};
  const colors = colorsFor(q);
  if (colors) props[PROP_COLORS] = colors;
  props[PROP] = giftText(q);
  return post('/cart/change.js', { line: line, quantity: q, properties: props }, btn);
}

/* Vaciar: se lleva tambien la proteccion de envio, que si no se queda sola. */
function vaciar(btn) {
  const d = box();
  if (!d) return;
  const updates = {};
  const vid = d.getAttribute('data-vid');
  const pid = d.getAttribute('data-prot-id');
  if (vid && vid !== '0') updates[vid] = 0;
  if (num(d, 'data-prot-line') > 0 && pid) updates[pid] = 0;
  if (!Object.keys(updates).length) return;
  post('/cart/update.js', { updates: updates }, btn);
}

/* Anade desde la ficha de producto y abre el cajon.
   El cajon se abre SOLO si de verdad se ha anadido: antes se abria
   siempre y, si la peticion fallaba, el cliente veia un carrito vacio. */
async function addPairs(variantId, qty, props, btn) {
  const d = box();
  const line = num(d, 'data-line');

  if (line > 0) {
    // Ya habia un pack en el carrito: lo quitamos y ponemos el nuevo,
    // porque pueden haber cambiado la talla o los colores.
    await post('/cart/change.js', { line: line, quantity: 0 }, btn);
  }

  const ok = await post('/cart/add.js', { items: [{ id: Number(variantId), quantity: qty, properties: props }] }, btn);
  if (ok) openDrawer();
}

/* Proteccion de envio: una linea aparte que se anade o se quita. */
function toggleProt(btn) {
  const d = box();
  if (!d) return;
  const line = num(d, 'data-prot-line');
  const vid = d.getAttribute('data-prot-id');
  if (line > 0) post('/cart/change.js', { line: line, quantity: 0 }, btn);
  else if (vid) post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }, btn);
}

/* ---------- Ficha de producto: anadir al carrito sin recargar ---------- */
document.addEventListener('submit', function (ev) {
  const form = ev.target && ev.target.closest ? ev.target.closest('#venora-form') : null;
  if (!form) return;
  ev.preventDefault();

  const fd = new FormData(form);
  const id = fd.get('id');
  let qty = parseInt(fd.get('quantity'), 10) || 1;
  if (qty < 1) qty = 1;
  if (qty > 3) qty = 3;
  if (!id) return;

  // Recogemos los properties[...] que haya puesto la ficha (colores, etc.).
  const props = {};
  fd.forEach(function (value, key) {
    if (key.indexOf('properties[') === 0 && key.charAt(key.length - 1) === ']') {
      const name = key.slice(11, -1);
      if (name && value) props[name] = value;
    }
  });
  props[PROP] = giftText(qty);

  addPairs(id, qty, props, form.querySelector('#venora-cta'));
}, true);

/* ---------- Clics del carrito ---------- */
document.addEventListener('click', function (ev) {
  const t = ev.target;
  if (!t || !t.closest) return;

  const step = t.closest('[data-v-step]');
  if (step) {
    ev.preventDefault();
    setPairs(num(box(), 'data-uds') + parseInt(step.getAttribute('data-v-step'), 10), step);
    return;
  }

  const set = t.closest('[data-v-set]');
  if (set) {
    ev.preventDefault();
    setPairs(parseInt(set.getAttribute('data-v-set'), 10), set);
    return;
  }

  const rm = t.closest('[data-v-remove]');
  if (rm) {
    ev.preventDefault();
    vaciar(rm);
    return;
  }

  const pr = t.closest('[data-v-prot]');
  if (pr) {
    ev.preventDefault();
    toggleProt(pr);
    return;
  }
});

/* ---------- Reserva de carrito: sesion real de 10 minutos ---------- */
function dos(n) { return n < 10 ? '0' + n : String(n); }

function inicio() {
  let t = 0;
  try { t = parseInt(sessionStorage.getItem('venora_reserva'), 10) || 0; } catch (e) {}
  if (!t) {
    t = Date.now();
    try { sessionStorage.setItem('venora_reserva', String(t)); } catch (e) {}
  }
  return t;
}

function reserva() {
  const wrap = document.querySelector('[data-v-res]');
  if (!wrap) return;
  const total = RESERVA_MIN * 60 * 1000;
  const falta = Math.max(0, total - (Date.now() - inicio()));
  if (falta === 0) { wrap.hidden = true; return; }
  wrap.hidden = false;
  const t = wrap.querySelector('[data-v-res-t]');
  const b = wrap.querySelector('[data-v-res-b]');
  if (t) t.textContent = Math.floor(falta / 60000) + ':' + dos(Math.floor((falta % 60000) / 1000));
  if (b) b.style.transform = 'scaleX(' + falta / total + ')';
}

/* Si el carrito queda en un numero que no vendemos, lo corrige solo. */
function revisa() {
  if (busy) return;
  const n = num(box(), 'data-uds');
  if (n > 3) setPairs(3);
}

/* Al cargar una página, repara carritos antiguos y elimina el regalo si
   el comprador volvió al pack de 1 par. */
syncEbookGift().then(async function (gift) {
  if (!gift) return;
  const html = gift.sections && gift.sections[SECTION];
  if (html) await morphSection(SECTION, html, { mode: 'hydration' });
  if (typeof gift.item_count === 'number') bumpCount(gift.item_count);
  tidyProps();
}).catch(function (e) {
  console.warn('[venora-ebook] No se pudo sincronizar el regalo al abrir la página:', e);
});

tidyProps();
reserva();
setTimeout(tidyProps, 800);
setInterval(reserva, 1000);
setInterval(revisa, 2500);
